import { render } from "./ShowAboutus.vue?vue&type=template&id=5fa6b428&scoped=true"
import script from "./ShowAboutus.vue?vue&type=script&lang=js"
export * from "./ShowAboutus.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./ShowAboutus.vue?vue&type=style&index=1&id=5fa6b428&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa6b428"]])

export default __exports__